module.exports = __webpack_public_path__ + "media/images/athletes/599-e6bc9d21df589e077cb4f5a01b92b827.png";